module.exports = __webpack_public_path__ + "img/technology-icon-3.fe3e2e97.png";